/**
 * Easing curve for animation fraction interpolation.
 * C++ Reference: FractionWarperCurve enum in tabanim
 */
export enum FractionWarperCurve {
  Linear = 'Linear',
  SinusoidalEaseInEaseOut = 'SinusoidalEaseInEaseOut',
}

/**
 * Timing for a single animation phase (enter, move, exit, or non-marks).
 * `delay` and `duration` are in dimensionless "slot" units; the resolver
 * normalizes them to the [0, 1] range before playback.
 *
 * C++ Reference: MarkAnimationTiming in tabanim/main/sceneanimation/MarkAnimationTiming.h
 */
export class MarkAnimationTiming {
  constructor(
    public delay: number,
    public duration: number,
    public warperCurve: FractionWarperCurve
  ) {}

  getEnd(): number {
    return this.delay + this.duration;
  }

  clone(): MarkAnimationTiming {
    return new MarkAnimationTiming(this.delay, this.duration, this.warperCurve);
  }

  toDebugString(): string {
    return `delay=${this.delay} dur=${this.duration}`;
  }
}
